<div class="update-project-phase-main-container">
    <div class="d-flex align-items-center justify-content-start gap-5">
        <div class="form-group">
            <label class="label" for="projectPhase">{{'project_team_dashboard_update_phase_modal_phase_label' | translate}}</label>
            <p-dropdown
                inputId="projectPhase"
                class="phase-dropdown"
                [(ngModel)]="updatedPhaseData.phase"
                [options]="phases"
                optionLabel="title"
                placeholder="{{'project_team_phase_input_placeholder' | translate}}"
                dropdownIcon="bi bi-caret-down-fill"
                (onChange)="onPhaseDropdownChange()"
                (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
            </p-dropdown>
        </div>
        <div class="form-group">
            <label class="label" for="phaseStartDate">{{'project_team_dashboard_update_phase_modal_date_label' | translate}}</label>
            <div class="calendar-wrapper">
                <p-calendar
                    #startDateCalendar
                    id="phaseStartDate"
                    [(ngModel)]="updatedPhaseData.date"
                    placeholder="{{'project_team_kick_off_date_input_placeholder' | translate}}"
                    [showIcon]="false"
                    dateFormat="d MM y"
                    [showButtonBar]="true"
                    class="date-calendar"
                    (onSelect)="onKickoffSelect()"
                    (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
                </p-calendar>
                <img class="calendar-icon" (click)="startDateCalendar?.toggle()" src="../../../../../assets/svg/m_info_icon_calendar.svg">
            </div>
        </div>
    </div>
    <div class="note-container">
        <i class="bi bi-question-circle-fill text-warning dn-question-icon"></i>
        <span class="note-text">{{'project_team_dashboard_update_phase_modal_note_text' | translate}}</span>
    </div>
</div>